import { h, Component } from 'preact';
import style from './style';

import { handleExternalLinksViaClickThru, validHex } from '../helper';
import { constants } from '../config';

export default class SkinV3MultiCta extends Component {
  render(props, state) {
    const useAppButtonsEnabled = props.customTagParams && props.customTagParams.useCta;
    const primaryBtnStyle = {
      backgroundColor: (props.customTagParams && validHex(props.customTagParams.cta_color_1)) ? props.customTagParams.cta_color_1 : 'transparent',
      borderColor: (props.customTagParams && validHex(props.customTagParams.cta_color_1)) ? props.customTagParams.cta_color_1 : 'transparent',
      color: (props.customTagParams && validHex(props.customTagParams.textColor)) ? props.customTagParams.textColor : '#454463',
    };
    const secondaryBtnStyle = {
      borderColor: (props.customTagParams && validHex(props.customTagParams.cta_color_2)) ? props.customTagParams.cta_color_2 : 'transparent',
      color: (props.customTagParams && validHex(props.customTagParams.cta_color_2)) ? props.customTagParams.cta_color_2 : '#454463',
    };
    const primaryLink = props.customTagParams && props.customTagParams.cta_link_1;
    const secondaryLink = props.customTagParams && props.customTagParams.cta_link_2;

    const primaryLabel = props.customTagParams && props.customTagParams.cta_label_1 || '';
    const secondaryLabel = props.customTagParams && props.customTagParams.cta_label_2 || '';
    const isVertical = ['top', 'bottom', 'middle'].includes(props.customTagParams && props.customTagParams.align);
    return (
      <div
        class={`${style.multiCtaWrapper} ${style[props.orientation]} ${isVertical ? style.vertical : ''}`}
      >
        <div class={`${style.multiCtaPreview} ${style[props.orientation]} ${isVertical ? style.vertical : ''} ${useAppButtonsEnabled ? style.appButtons : ''}`}>
          {useAppButtonsEnabled ? <div class={style.ctaBtnWrapper}>
            <div class={`${style.multiCtaBtn} ${style.playStore}`} onClick={() => this.handleClick(primaryLink, 'Play Store')} />
            <div class={`${style.multiCtaBtn} ${style.appStore}`} onClick={() => this.handleClick(secondaryLink, 'App Store')} />
          </div> : <div class={style.ctaBtnWrapper}>
            <div class={style.multiCtaBtn} style={secondaryBtnStyle} onClick={() => this.handleClick(secondaryLink, secondaryLabel)}>{secondaryLabel}</div>
            <div class={style.multiCtaBtn} style={primaryBtnStyle} onClick={() => this.handleClick(primaryLink, primaryLabel)}>{primaryLabel}</div>
          </div>}
        </div>
      </div>
    );
  }

  getEngagements = (props = this.props) => {
    if (props.tag.settings.subcategory) {
      return [].concat.apply(
        [],
        props.tag.settings.subcategory.map((item) => item.engagements)
      );
    }
    return [];
  };

  handleClick = (link, label) => {
    if(link) {
      // window.open(link);
      // OneAd clickThru---
      handleExternalLinksViaClickThru(link, this.props.creativeData);
      //---
      this.logCommerceEvent(label)
    }
  };


  logCommerceEvent = (actionLabel) => {
    let engagements = this.getEngagements();
    let action = engagements && engagements[0];
    let actionValueFormtted = action.slug;

    let tag_id = this.props.tag.id;
    let tag_label =
      this.props.tag &&
      this.props.tag.details &&
      (this.props.tag.details.preview_title || this.props.tag.details.title);
    let engagement_id = action && action.id;
    let engagement_label = actionLabel;

    let logDataObj = {
      event: 'engagement',
      type: actionValueFormtted,
      sub_type: null,
      event_type: actionValueFormtted,
      tag_id,
      tag_label,
      engagement_id,
      engagement_label,
      current_duration: this.props.getCurrentTime(),
    };

    this.props.logDataEvent(logDataObj);
  };

}



// WEBPACK FOOTER //
// ./components/skinV3MultiCta/index.js